import React, { useContext, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import AuthContext from "../../../context/AuthContext";

import styles from "./styles/HomePage.module.css";
import { Helmet } from 'react-helmet';
import ScenarioCarousels from './ScenarioCarousels';
import { FaSearch } from 'react-icons/fa';

const HomePage = () => {
    const { loggedIn } = useContext(AuthContext);
    const location = useLocation();
    const navigate = useNavigate();
    const [showVerified, setShowVerified] = useState(false);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    // Surfaced once after a successful email verification (backend redirects here
    // with ?verified=true). Strip the param so a refresh doesn't re-show it.
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        if (params.get('verified') === 'true') {
            setShowVerified(true);
            navigate('/home', { replace: true });
        }
    }, [location.search, navigate]);

    return (
        loggedIn === true && (
            <>
                {showVerified && (
                    <div className={styles.verifiedBanner}>
                        Your email has been verified — welcome! You're all set.
                        <button
                            type="button"
                            className={styles.verifiedBannerClose}
                            aria-label="Dismiss"
                            onClick={() => setShowVerified(false)}
                        >
                            ×
                        </button>
                    </div>
                )}
                <>
                    <ScenarioCarousels />
                </>
            </>
        )
    );
};

export default HomePage;
